exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product .quantity-select-action input[type='number'][data-v-bc42e2f6] {\n  padding: 0;\n}\n.product + .product[data-v-bc42e2f6] {\n  border-top-width: 1px;\n  border-color: #d0d0d0;\n}\n", ""]);

// exports
